import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

let API_URL = "/manufacturer-vendors";
let COMPONENT_URL = "/manufacturer/vendors";
let COMPONENT_DETAILS_URL = "/manufacturer/vendors";

let filterBy = [
  { name: "All", value: "all" },
  { name: "ID", value: "vendorId" },
  { name: "Vendor Name", value: "name" },
  { name: "Contact Name", value: "contactName" },
  { name: "Contact Number", value: "contactNumber" },
  { name: "Address", value: "address" },
  { name: "Terms", value: "terms" },
  { name: "Additional Details", value: "additionalDetails" },
];

let limits = [5, 10, 15, 20];

export default function Vendors() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);

  /*   ALL STATES
   ********************************************* */

  const [vendorsData, setVendorsData] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1,
  );
  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }
  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const handleFilterBy = (filter) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filter);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);
    return params.toString();
  };

  //get Data
  const getVendorsData = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      // check for sort and order in searchParams
      let sort = searchParams.get("sort");
      let order = searchParams.get("order");
      if (sort && order) {
        body.sort = sort;
        body.order = order;
      }

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setVendorsData(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteVendorsData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/manufacturer-vendor/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        setVendorsData((prev) => prev.filter((item) => item.id !== id));
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          }),
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        }),
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  // Adds Button Function
  const handleVendorsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post("/manufacturer-vendor", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        setVendorsData((prev) => [...prev, data?.data]);
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const handleUpdateVendorsData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch("/manufacturer-vendor/", formData, {
        headers: authHeader(),
      });
      if (data?.success) {
        setVendorsData((prev) => {
          const newData = prev.map((item) => {
            if (item.id === formData.id) {
              return data?.data;
            }
            return item;
          });
          return newData;
        });
        setIsUpdateMode(false);
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }
      getVendorsData();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        {(user?.permissions?.includes("m_vendor_add") ||
          user?.roles === "admin") && (
          <button
            onClick={() => {
              setShowAddModal(true);
              setFormData({});
              setIsUpdateMode(false);
            }}
            type="button"
            className="btn btn-primary"
          >
            Add Vendors
          </button>
        )}
      </>
    </div>
  );

  const table_head = [
    { name: "ID", value: "vendorId" },
    { name: "Vendor Name", value: "name" },
    { name: "Contact Name", value: "contactName" },
    { name: "Contact Number", value: "contactNumber" },
    { name: "Address", value: "address" },
    { name: "Terms", value: "terms" },
    { name: "Additional Details", value: "additionalDetails" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="align-middle py-1">{item.vendorId}</td>
      <td className="align-middle py-1">{item.name}</td>
      <td className="align-middle py-1">{item.contactName}</td>
      <td className="align-middle py-1">{item.contactNumber}</td>
      <td className="align-middle py-1">
        {item?.address?.length > 30
          ? `${item?.address?.slice(0, 30)}...`
          : item.address}
      </td>
      <td className="align-middle py-1">
        {item?.terms?.length > 30
          ? `${item?.terms?.slice(0, 30)}...`
          : item.terms}
      </td>
      <td className="align-middle py-1">
        {item?.additionalDetails?.length > 30
          ? `${item?.additionalDetails?.slice(0, 30)}...`
          : item.additionalDetails}
      </td>
      <td className="table-action align-middle py-1">
        {(user?.permissions?.includes("m_vendor_update") ||
          user?.roles === "admin") && (
          <button
            disabled={loading}
            onClick={() => {
              handleUpdateData(item);
            }}
            className="btn px-1"
          >
            <i className="mdi mdi-pencil"></i>
          </button>
        )}

        {(user?.permissions?.includes("m_vendor_delete") ||
          user?.roles === "admin") && (
          <DeleteModalButton
            btnClass={"btn  px-1"}
            deleteFunc={deleteVendorsData}
            deleteParams={item.id}
            disableConditions={loading}
          />
        )}
      </td>
    </tr>
  );

  return (
    <div className="p-2" style={{ marginLeft: 260, height: "100vh" }}>
      <h2 className="mb-3 px-2">Vendors</h2>
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div className="px-2" style={{ minHeight: "50vh", borderRadius: 15 }}>
        <div className="">
          <div className="">
            <div className="d-flex justify-content-end align-items-center gap-1 mb-3">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="bg-opacity-10 border border-primary rounded-end rounded-start"
                    >
                      {filterBy.find(
                        (filter) =>
                          filter.value === searchParams.get("filterBy") ||
                          (searchParams.get("filterBy") === null &&
                            filter.value === "all"),
                      )?.name || "Filter By"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {filterBy.map((filter) => (
                        <Dropdown.Item
                          key={filter.value}
                          onClick={() => handleFilterBy(filter.value)}
                        >
                          {filter.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
              <SearchComp
                setLoading={setLoading}
                apiPath={`${COMPONENT_URL}${
                  getSearchParamsWithoutGivenKey("query")
                    ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                    : "?"
                }`}
              />
              <div className="">{btn1()}</div>
            </div>

            <div
              className="px-1 flex-grow-1 overflow-y-auto d-flex"
              style={{ height: "78vh", borderRadius: 15 }}
            >
              <div className="horizontal-scrollable d-flex flex-grow-1">
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={searchResults ? searchResults : vendorsData}
                  totalPages={totalPages}
                />
              </div>
            </div>

            {loading && <Spinner />}
            {!searchResults && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <div className="">
            <h4>{isUpdateMode ? "Update Vendors" : "Add Vendors"}</h4>
          </div>
          <hr className="mt-0" />
          <form
            onSubmit={
              isUpdateMode ? handleUpdateVendorsData : handleVendorsData
            }
            className=""
          >
            <div className="mb-3">
              <label className="">Vendor Name</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.name || ""}
                  onChange={(e) => {
                    setFormData({ ...formData, name: e.target.value });
                  }}
                  className="form-control"
                  placeholder="Enter Vendor Name"
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="">Contact Name</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.contactName || ""}
                  onChange={(e) => {
                    setFormData({ ...formData, contactName: e.target.value });
                  }}
                  className="form-control"
                  placeholder="Enter Contact Name"
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="">Contact Number</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.contactNumber || ""}
                  onChange={(e) => {
                    setFormData({ ...formData, contactNumber: e.target.value });
                  }}
                  className="form-control"
                  placeholder="Enter Contact Number"
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="">Address</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.address || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      address: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter Contact Number"
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="">Terms</label>
              <div className="">
                <input
                  type="text"
                  value={formData?.terms || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      terms: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter Terms"
                  as="textarea"
                  rows="3"
                />
              </div>
            </div>
            <div className="mb-3">
              <label className="">Additional Details</label>
              <div className="">
                <textarea
                  value={formData?.additionalDetails || ""}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      additionalDetails: e.target.value,
                    });
                  }}
                  className="form-control"
                  placeholder="Enter Additional Details"
                  rows="3"
                />
              </div>
            </div>

            {/*   buttons
             ********************************************* */}
            <div className="mt-3">
              <div className="d-flex justify-content-end">
                <button
                  onClick={() => {
                    setShowAddModal(false);
                  }}
                  className="btn btn-secondary btn-sm"
                  type="button"
                >
                  Close
                </button>
                <button
                  disabled={loading}
                  className="btn btn-primary btn-sm ms-1"
                  type="submit"
                >
                  {isUpdateMode ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
